import { Root_default } from "./chunk-AIUNIP5D.js";
import { TransitionComponent } from "./chunk-3HAR27K6.js";
import { __objRest, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/Dialog/Dialog.tsx
import React, { Fragment } from "react";
import clsx from "clsx";
import { Dialog as HeadlessDialog } from "@headlessui/react";
var DIALOG_CLASSNAME_MAP = {
  size: {
    sm: "pd-dialog--sm",
    md: "pd-dialog--md",
    lg: "pd-dialog--lg"
  }
};
var Dialog = _a => {
  var _b = _a,
    {
      isOpen,
      size = "md",
      children,
      className
    } = _b,
    rest = __objRest(_b, ["isOpen", "size", "children", "className"]);
  return (
    // Adding <Root> because the Dialog is rendered in a React Portal, so it's outside of the usual <Root>
    /* @__PURE__ */
    React.createElement(TransitionComponent, {
      show: isOpen,
      as: Fragment
    }, /* @__PURE__ */React.createElement(Root_default, __spreadValues({
      as: HeadlessDialog
    }, rest), /* @__PURE__ */React.createElement("section", {
      className: clsx("pd-dialog", DIALOG_CLASSNAME_MAP.size[size], className)
    }, children)))
  );
};
var Dialog_default = Dialog;
export { Dialog_default };